import Link from "components/elements/link"
import {
  caretDownDesktop,
  caretUpDesktop,
} from "components/sections/headerV2/TopNav/Menu/Links/icons"
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import "./departments.scss"

import DropdownMultiSelect from "components/elements/DropdownMultiSelect"
import searchIcon from "images/search.png"

const DepartmentsList = ({ backgroundColor }) => {
  const [jobsData, setJobsData] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedDepartments, setSelectedDepartments] = useState([])
  const [selectedStates, setSelectedStates] = useState([])
  const [states, setStates] = useState([])
  const [departments, setDepartments] = useState([])
  const [tempSearchTerm, setTempSearchTerm] = useState("")
  const [expandedStates, setExpandedStates] = useState({})
  const labelForState = s => (s === "Other" ? "Remote" : s)

  const toggleState = stateName => {
    setExpandedStates(prev => ({
      ...prev,
      [stateName]: !prev[stateName],
    }))
  }
  const filteredJobs = useMemo(() => {
    return jobsData.filter(job => {
      const titleMatch = job.title
        .toLowerCase()
        .includes(searchTerm.toLowerCase())

      const departmentMatch =
        selectedDepartments.length > 0
          ? (job.departments || []).some(dep =>
              selectedDepartments.includes(dep.name)
            )
          : true

      const state = job.location?.name?.split(",")?.[1]?.trim()
      const stateMatch =
        selectedStates.length > 0 ? selectedStates.includes(state) : true

      return titleMatch && departmentMatch && stateMatch
    })
  }, [jobsData, searchTerm, selectedDepartments, selectedStates])

  const jobsByState = useMemo(() => {
    return filteredJobs.reduce((acc, job) => {
      const state = job.location?.name?.split(",")?.[1]?.trim() || "Other"
      if (!acc[state]) acc[state] = []
      acc[state].push(job)
      return acc
    }, {})
  }, [filteredJobs])

  useEffect(() => {
    fetch(
      "https://boards-api.greenhouse.io/v1/boards/cortica/jobs?content=true"
    )
      .then(res => res.json())
      .then(result => {
        const jobs = result.jobs
        const statesSet = new Set()
        const departmentsSet = new Set()
        jobs.forEach(job => {
          const locationParts = job.location?.name?.split(",")
          const state = locationParts?.[1]?.trim()
          if (state) statesSet.add(state)
          if (job.departments?.length) {
            job.departments.forEach(dep => departmentsSet.add(dep.name))
          }
        })
        const statesArray = Array.from(statesSet).sort()
        setJobsData(jobs)
        setStates(statesArray)
        setDepartments(Array.from(departmentsSet).sort())

        const initialExpandedStates = {}
        statesArray.forEach(state => {
          initialExpandedStates[state] = true
        })
        setExpandedStates(initialExpandedStates)
      })
  }, [])
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchTerm(tempSearchTerm)
    }, 300)

    return () => clearTimeout(handler)
  }, [tempSearchTerm])

  useEffect(() => {
    const stateKeys = Object.keys(jobsByState)
    const next = {}
    stateKeys.forEach(s => {
      next[s] = true
    })
    setExpandedStates(next)
  }, [jobsByState])

  return (
    <div
      className="career careers-bg"
      id="explore-jobs-by-state"
      style={{ backgroundColor }}
    >
      <div className="container">
        <div className="headline-wrapper">
          <div className="header">Explore Jobs by State</div>
          <div className="sub-header">
            We&apos;re growing quickly, which provides teammates with abundant
            opportunities to explore their professional passions and advance in
            their disciplines. If you&apos;re interested in joining a team that
            is transforming neurodevelopmental care, look no further than
            Cortica.
          </div>
        </div>
        <div className="filters-row">
          <div className="filter-input">
            <input
              onChange={e => setTempSearchTerm(e.target.value)}
              placeholder="Search Job Title"
              type="text"
              value={tempSearchTerm}
            />

            <button className="search-button">
              <img alt="Search" className="search" src={searchIcon} />
            </button>
          </div>

          <DropdownMultiSelect
            options={departments}
            placeholder="Filter by Department"
            selectedOptions={selectedDepartments}
            setSelectedOptions={setSelectedDepartments}
          />

          <DropdownMultiSelect
            options={states}
            placeholder="Filter by State"
            selectedOptions={selectedStates}
            setSelectedOptions={setSelectedStates}
          />
        </div>
        <div className="job-groups">
          {Object.keys(jobsByState)
            .sort()
            .map(state => {
              const isExpanded = expandedStates[state] ?? true

              return (
                <div className="state-group" key={state}>
                  <div
                    className="state-header"
                    onClick={() => toggleState(state)}
                    onKeyDown={e => {
                      if (e.key === "Enter" || e.key === " ") {
                        toggleState(state)
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    <h3 className="state-title">
                      {labelForState(state)} Roles
                      <span className="caret-icon">
                        {isExpanded ? caretUpDesktop : caretDownDesktop}
                      </span>
                    </h3>
                  </div>

                  {isExpanded && (
                    <div className="job-list">
                      {jobsByState[state].map(job => (
                        <div className="job-item" key={job.id}>
                          <Link
                            rel="noopener"
                            target="_blank"
                            to={job.absolute_url}
                          >
                            {job.title}
                          </Link>
                          <span className="job-location">
                            {job.location?.name?.replace(
                              /,\s*United States$/i,
                              ""
                            )}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )
            })}

          {Object.keys(jobsByState).length === 0 && (
            <p className="no-results">No jobs found matching your filters.</p>
          )}
        </div>
      </div>
    </div>
  )
}

export const DepartmentsListProps = {
  backgroundColor: PropTypes.string,
}

DepartmentsList.propTypes = DepartmentsListProps

export default DepartmentsList
